import { db } from '../lib/firebase';
import { collection, doc, getDoc, setDoc, updateDoc, query, where, getDocs } from 'firebase/firestore';
import { User } from '../types/user';
import { Organization } from '../types/organization';

export const userService = {
  async createUserIfNotExists(user: any) {
    const userRef = doc(db, 'users', user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      // Check if this is the first user ever
      const usersCollection = collection(db, 'users');
      const usersQuery = query(usersCollection);
      const usersSnapshot = await getDocs(usersQuery);

      const isFirstUser = usersSnapshot.empty;
      const role = isFirstUser ? 'super_admin' : 'user';

      // If this is the first user, create an organization
      let organizationId = '';
      if (isFirstUser) {
        const orgRef = doc(collection(db, 'organizations'));
        const organization: Organization = {
          id: orgRef.id,
          name: 'Default Organization',
          ownerId: user.uid,
          taxNumber: '',
          registrationNumber: '',
          address: {
            street: '',
            city: '',
            postalCode: '',
            country: ''
          },
          contact: {
            name: user.displayName || '',
            email: user.email || '',
            phone: '',
            position: ''
          },
          users: [{
            userId: user.uid,
            email: user.email,
            role: 'admin',
            addedAt: new Date()
          }],
          isActive: true,
          createdAt: new Date(),
          updatedAt: new Date()
        };

        await setDoc(orgRef, organization);
        organizationId = orgRef.id;
      }

      // Create new user
      const newUser: User = {
        id: user.uid,
        email: user.email,
        displayName: user.displayName || '',
        photoURL: user.photoURL || '',
        role: role,
        organizationId: organizationId,
        createdAt: new Date(),
        updatedAt: new Date(),
        lastLoginAt: new Date()
      };

      await setDoc(userRef, newUser);
      return newUser;
    }

    const userData = userSnap.data() as User;
    // Ensure the id field is always present
    return {
      ...userData,
      id: user.uid
    };
  },

  async getUser(userId: string): Promise<User | null> {
    try {
      const userRef = doc(db, 'users', userId);
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        return userSnap.data() as User;
      }
      return null;
    } catch (error) {
      console.error('Error getting user:', error);
      return null;
    }
  },

  async updateUser(userId: string, data: Partial<User>): Promise<void> {
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, {
        ...data,
        updatedAt: new Date()
      });
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  }
}; 